import classNames from 'classnames';
import {useLocation, useNavigate} from 'react-router-dom';

const Header = ({title}: IMainHeaderProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isFarm = location.pathname.includes('farm');

  return (
    <>
      <div
        className={classNames(
          ' bg-white flex justify-between p-4  -mx-3 sticky top-0 z-10 ',
          {'shadow-lg': isFarm},
        )}
      >
        <span
          onClick={() => navigate(-1)}
          className="icon-arrow_left text-gray-6 text-2xl"
        ></span>
        <p className=" text-sm">{title}</p>
        <div></div>
      </div>
    </>
  );
};

export default Header;
